import { service_list } from '@/plugins/odoo'
import { TitleServiceCut } from '@/plugins/odoo_table'
const agruparServicios = async () => {
    const data = await service_list()
    const result = [];
    let index = 0;
    Object.values(data).forEach(cliente => {
      const nuevoCliente = {
        posCliente: index,
        display_name: cliente.display_name,
        id: cliente.id,
        service: []
      };
      const serviciosAgrupados = {};
      Object.values(cliente.services).forEach(servicio => {
        let parent = null;
        if (servicio.service_type == "FTTH"  || servicio.service_type == "WISP") {
          parent = servicio.id
        } else {
          if (servicio.unido_con.length > 0) {
            servicio.unido_con.forEach( su => {
              const searchSA = Object.values(serviciosAgrupados).filter( sa => {
                return sa.service_id_parent == su
              })
              if (searchSA.length == 1) {
                serviciosAgrupados[su.toString()].service.push(servicio)
              } else {
                console.log(searchSA)
              }
              
            })
          } else {
            parent = servicio.id
          }
        }
        if (parent != null) {
          serviciosAgrupados[servicio.id.toString()] = ({
            service_id_parent: parent,
            contrato: servicio.display_name,
            service: [ servicio ]
          })
        }
      })
      if (Object.values(serviciosAgrupados).length > 0) {
        Object.values(serviciosAgrupados).forEach(grupo => {
          nuevoCliente.service.push(grupo);
        });
        result.push(nuevoCliente);
      }
      index++
    });
    return result;
}
export {
    service_list,
    TitleServiceCut,
    agruparServicios
}